<template>

    <input type="text" placeholder="0" v-model="model" class="input" />

</template>

<script>

export default {

    props: ['value', 'type', 'rule'],

    data: function() {

        return {
            model: ''
        }

    },

    created: function() {

        this.model = this.value

    },

    watch: {

        value: function(n) {

            this.model = n

        },

        model: function(n) {

            this.$emit('input', n)

        }

    }

}

</script>

<style scoped>

.input {
    background-color: #fff;
    border-radius: 4px;
    font-size: 14px;
    color: #333;
    height: 40px;
    width: 40px;
    font-weight: 400;
    text-align: center;
}

.is-mobile .input {
    border: 1px solid #eee;
}

.input::placeholder {
    color: #999;
}

</style>